// extracted by mini-css-extract-plugin
export default {"root":"styles_root__5O+Ke","link":"styles_link__6aGD8","image":"styles_image__WXp9Y","button":"styles_button__dxjrZ"};